import { useContext } from 'react';

import { GroupSubscriptionsContext } from './GroupSubscriptionsContext';

export const useGroupSubscriptionsContext = () => {
  const context = useContext(GroupSubscriptionsContext);
  if (!context) {
    throw new Error('useGroupSubscriptionsContext must be used within a GroupSubscriptionsProvider');
  }
  return context;
};
